export default "__VITE_ASSET__Bh_JOsA8__";